import { render } from "./CampaignType.vue?vue&type=template&id=fc7675d4&scoped=true"
import script from "./CampaignType.vue?vue&type=script&lang=js"
export * from "./CampaignType.vue?vue&type=script&lang=js"

import "./CampaignType.vue?vue&type=style&index=0&id=fc7675d4&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7675d4"]])

export default __exports__